import React, { useState, Fragment } from "react";
import {
  Badge,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown as ReactStrapDropDown,
} from "reactstrap";
import Item from "./Item";
import style from "./../style.module.scss";
import { classifyAuthorizations } from "../types";

const List = ({ items, username, role, toggleModal, routes, link, setRead }) => {
  const [open, setOpen] = useState(false);
  const [groups, counter] = classifyAuthorizations(items, username, role);

  const toggle = () => setOpen(!open);

  const actions = {
    toggle: toggleModal,
    read: setRead,
  };

  return (
    <ReactStrapDropDown nav isOpen={open} toggle={toggle}>
      <DropdownToggle nav>
        <span className={counter ? style.tada : null}>
          <i className="icon-bell"></i>
          <Badge pill color="warning">
            {counter >= 15 ? "15+" : isNaN(counter) ? "-" : counter}
          </Badge>
        </span>
      </DropdownToggle>
      <DropdownMenu right tag="div">
        <div className={style.container}>
          <DropdownItem header tag="div" className="text-center">
            <strong>Authorizations</strong>
          </DropdownItem>
          {items && items.length == 0 && (
            <h6 className={style.empty} style={{ textAlign: "center" }}>
              No Authorizations
            </h6>
          )}
          {items && (
            <Fragment>
              <ItemGroup header="To response" items={groups.todo} {...actions} />
              <ItemGroup header="Unread" items={groups.unread} {...actions} />
              <ItemGroup header="Waiting" items={groups.waiting} {...actions} />
            </Fragment>
          )}
        </div>
        <DropdownItem tag={link} to={routes["ViewAll"].to} className={`view-more ${style.more}`}>
          View all authorizations
        </DropdownItem>
      </DropdownMenu>
    </ReactStrapDropDown>
  );
};

const ItemGroup = ({ header, items, toggle, read }) => {
  if (!items || items.length == 0) {
    return null;
  }

  return (
    <Fragment>
      <DropdownItem header tag="div" className={style.header}>
        {header}
        <span className="ml-2">({items.length})</span>
      </DropdownItem>
      {items.map((item) => (
        <Item key={`di-${item.id}`} item={item} group={header} toggleModal={toggle} setRead={read} />
      ))}
    </Fragment>
  );
};

export function getRoute(routes, process) {
  const route = routes[process] || { to: "/" };
  return route.to;
}

export default List;
